import { gql, useQuery } from '@apollo/client'
import PageComponent from 'components/Dashboard/PageComponent'
import { format } from 'date-fns'
import { Link } from 'gatsby'
import BatchList from './BatchList'
import { DashboardTitle } from './DashboardTitleContext'
import { RecentVisionManifests } from './__generated__/RecentVisionManifests'

const formatDate = (dateString: string) => format(new Date(dateString), 'dd MMM yyyy, hh:mm aa')

const recentManifestsQuery = gql`
  query RecentVisionManifests {
    recentVisionManifests {
      id
      receivedDate
      subject
      from
      totalItems
      ignoredItems
      b2bItems
      b2cItems
    }
  }
`

const RecentManifests = () => {
  const { loading, error, data } = useQuery<RecentVisionManifests>(recentManifestsQuery)

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error! {error.message}</div>
  }

  return (
    <table className="table is-bordered">
      <thead>
        <tr>
          <th>Received</th>
          <th>From</th>
          <th>Subject</th>
          <th>Items</th>
        </tr>
      </thead>
      <tbody>
        {data.recentVisionManifests.map((manifest) => (
          <tr key={manifest.id}>
            <td>
              <Link to={`/dashboard/vision/manifest/${manifest.id}`}>{formatDate(manifest.receivedDate)}</Link>
            </td>
            <td>{manifest.from}</td>
            <td>{manifest.subject}</td>

            <td>
              {manifest.totalItems} ({manifest.ignoredItems} ignored, {manifest.b2bItems} B2B, {manifest.b2cItems} B2C)
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const Vision: PageComponent = () => (
  <div className="container">
    <DashboardTitle title="Vision" />

    <h2 className="subtitle is-4">Recent Outbound Batches</h2>
    <BatchList batchClass="Vision" />

    <h2 className="subtitle is-4">Recent Inbound Manifests</h2>
    <RecentManifests />
  </div>
)

Vision.path = '/vision'
Vision.displayName = 'Vision'

export default Vision
